import React from 'react';

const InstantCheckoutTooltip = () => {
  return (
    <>
      <h3 className="ic-tooltip__header tooltip_title">
        <div className="instant-checkout-tooltip__header-text">Instant Checkout Settings</div>
      </h3>
      <div className="ic-hint__text">
        <div>Make a purchase in just one step with your saved information:</div>
        <ul className="list ic-tooltip__list">
          <li className="diy__link--bold">Delivery address</li>
          <li className="diy__link--bold">Payment method</li>
        </ul>
        <a className="u__default-link" href="/account/view/instantcheckout">
          {' '}
          Get started now
        </a>
      </div>
    </>
  );
};

export { InstantCheckoutTooltip };
